import Api from 'libs/api';

class CategoriesApi extends Api {
  constructor() {
    super('admin/categories');
  }
}

export default CategoriesApi;
